<template>
  <div class="wrap">
    <div class="heard">
      <van-tabs v-model="currentTab" @change="change" color="#3E78F7" line-width="70px">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.text"></van-tab>
      </van-tabs>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-empty v-if="!loading&&dataList.length == 0" style="width: 100%" description="暂无数据" />
      <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
        <div class="content-m">
              <mqztc-card :list="dataList"></mqztc-card>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import mqztcCard from '@/views/common/mqztc-card'
import { getAction, postAction } from '@/api/manage'
export default {
  components: {
    mqztcCard,
  },
  data() {
    return {
      dbList: [],
      ybList: [],
      dataList:[],
      pageNo: '1',
      currentTab:0,
      loading:true,
      lx:'01',
      tabs: [
        {
          text: '待回复',
          code: '01',
        },
        {
          text: '已回复',
          code: '02',
        },
      ],
    }
  },
  created() {
    let index =  sessionStorage.getItem('mqztc-index')||0;
    this.currentTab = Number(index);
    this.lx = this.tabs[index].code;
    this.onRefresh()
  },
  methods: {
    change(index) {
      this.dataList = [];
      this.lx = this.tabs[index].code;
      sessionStorage.setItem('mqztc-index',index);
      this.onRefresh()
    },
    getData() {
      let params = { pageNo: this.pageNo,lx:this.lx }
      getAction('/zhshj/ztchf/page/app', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
     
    onLoad() {
      this.pageNo++
      this.getData();
    },
    clickItem(item) {},
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 1
      this.refreshing = true;
      this.getData();
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 44px;
  box-sizing: border-box;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
::v-deep .van-pull-refresh {
   min-height:calc(100vh - 44px)
}

.content-m{
  min-height:calc(100vh - 44px)
}
</style>
